/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  CHANGE_PASSWORD,
  GET_USERS_LIST,
  GET_USER_DETAILS,
  LOGIN,
  LOGOUT,
  UPDATE_USER_DETAILS,
  UPDATE_USER_EMAIL_DETAILS,
  VERIFY_USER_EMAIL_DETAILS,
  EXTERNAL_CANDIDATE_REGISTRATION,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  FETCH_RANDOM_USERNAME_PWD,
  REGISTER_CANDIDATE_ACTION,
  GET_QUALIFICATION,
} from '../constants/action-types'
import { ThunkAction } from 'redux-thunk'
import { Action, Store } from 'redux'
import {
  CHANGE_PASSWORD_URL,
  UPDATE_USER_DETAILS_URL,
  USER_SIGNIN,
  REGISTRATION_URL,
  FORGOT_PASSWORD_URL,
  RESET_PASSWORD_URL,
  FETCH_RANDOM_USERNAME_PWD_URL,
  GET_QUALIFICATION_URL,
} from '../../service/apiEndPoints'
import { setToken, showErrorToastMessage, successToast } from '../../util/utils'
import { setEncryptRole } from '../../util/crypto'

export const login =
  (
    username: any,
    password: any,
    bid?: string,
    is_corporate?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(loginInit(username, password, bid, is_corporate))
  }

export const loginInit =
  (
    username: any,
    password: any,
    bid?: string,
    is_corporate?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: LOGIN.LOGIN_INITIALIZATION,
    })
    apiCall(
      USER_SIGNIN,
      (res: any) => dispatch(loginSuccess(res, username, password)),
      (err: any) => {
        dispatch(loginError(err))
      },
      {
        username,
        password,
        bid: bid || undefined,
        is_corporate: is_corporate,
      },
      METHOD.POST,
      { showToast: true }
    )
  }

export const loginSuccess =
  (
    res: any,
    username: any,
    password: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    localStorage.setItem('refresh-token', res.data.refresh)
    localStorage.setItem(
      'institute-details',
      JSON.stringify(res?.data?.user?.institute)
    )
    setToken('login-auth-token', res.data.access).then(function () {
      setToken('isLoggedIn', 'true')
      setEncryptRole(res?.data?.user?.role)
      dispatch({
        type: LOGIN.LOGIN_SUCCESS,
        payload: { response: res, username, password },
      })
    })
  }

export const loginError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: LOGIN.LOGIN_ERORR,
      payload: err?.data?.message || err?.data?.message?.non_field_errors,
    })

    const field = Object.keys(err?.data?.message)[0]

    const emailNotInvited =
      'not_invited' === field && 'You are not invited to this batch.'

    showErrorToastMessage(emailNotInvited)
  }

// ************** Logout ******************

export const logout =
  (showToast = true): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(logoutInit(showToast))
  }

export const logoutInit =
  (showToast = true): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: LOGOUT.LOGOUT_INITIALIZATION,
    })
    dispatch(logoutSuccess(showToast))
  }

export const logoutSuccess =
  (showToast = true): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    localStorage.clear()

    dispatch({
      type: LOGOUT.LOGOUT_SUCCESS,
      payload: {},
    })
  }

export const logoutError =
  (): ThunkAction<void, Store, unknown, Action<string>> => (dispatch) => {
    dispatch({
      type: LOGOUT.LOGOUT_ERORR,
    })
  }

// ************** changePassword ******************

export const changePassword =
  (
    showToast = true,
    password: any,
    onSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(changePasswordInit(showToast, password, onSuccess))
  }

export const changePasswordInit =
  (
    showToast: boolean,
    password: any,
    onSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD.CHANGE_PASSWORD_INITIALIZATION,
    })
    apiCall(
      CHANGE_PASSWORD_URL,
      (res) => dispatch(changePasswordSuccess(onSuccess, res)),
      (err: any) => {
        dispatch(changePasswordError(err))
      },
      password,
      METHOD.POST,
      { showToast: showToast }
    )
  }

export const changePasswordSuccess =
  (
    onSuccess?: () => void,
    res?: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD.CHANGE_PASSWORD_SUCCESS,
    })
    successToast(res?.message)
    onSuccess && onSuccess()
  }

export const changePasswordError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD.CHANGE_PASSWORD_ERORR,
      payload: err.message,
    })
    showErrorToastMessage(
      err?.data?.current_password?.[0] || err?.data?.password?.[0]
    )
  }
// ************** User details Get ******************
export const userDetailsGet =
  (
    showToast = true,
    ID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(userDetailsGetInit(showToast, ID))
  }

export const userDetailsGetInit =
  (
    showToast: boolean,
    ID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_USER_DETAILS.GET_USER_DETAILS_INITLIZATION,
    })
    apiCall(
      UPDATE_USER_DETAILS_URL + `/${ID}`,
      (res: any) => dispatch(userDetailsGetSuccess(res)),
      (err: any) => {
        dispatch(userDetailsGetError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const userDetailsGetSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_USER_DETAILS.GET_USER_DETAILS_SUCCESS,
      payload: res,
    })
  }

export const userDetailsGetError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_USER_DETAILS.GET_USER_DETAILS_ERORR,
      payload: err.message,
    })
  }

// ************** User details Update ******************

export const userDetailsUpdate =
  (
    showToast = true,
    details: any,
    UID: any,
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>,
    handleSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    setLoading && setLoading(true)
    dispatch(
      userDetailsUpdateInit(showToast, details, UID, setLoading, handleSuccess)
    )
  }

export const userDetailsUpdateInit =
  (
    showToast: boolean,
    details: any,
    UID: any,
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>,
    handleSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_USER_DETAILS.UPDATE_USER_DETAILS_INITIALIZATION,
    })
    apiCall(
      UPDATE_USER_DETAILS_URL + `/${UID}`,
      (res) => {
        dispatch(userDetailsUpdateSuccess(res, setLoading))
        handleSuccess && handleSuccess()
      },
      (err: any) => {
        dispatch(userDetailsUpdateError(err, setLoading))
      },
      details,
      METHOD.PUT,
      { showToast: showToast }
    )
  }

export const userDetailsUpdateSuccess =
  (
    res: any,
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_USER_DETAILS.UPDATE_USER_DETAILS_SUCCESS,
      payload: res,
    })
    setLoading && setLoading(false)
  }

export const userDetailsUpdateError =
  (
    err: any,
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_USER_DETAILS.UPDATE_USER_DETAILS_ERORR,
      payload: err.message,
    })
    setLoading && setLoading(false)
  }

// ************** User Email Update ******************

export const userEmailUpdate =
  (
    showToast = true,
    details: any,
    UID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(userEmailUpdateInit(showToast, details, UID))
  }

export const userEmailUpdateInit =
  (
    showToast: boolean,
    details: any,
    UID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_USER_EMAIL_DETAILS.UPDATE_USER_EMAIL_DETAILS_INITIALIZATION,
    })
    apiCall(
      UPDATE_USER_DETAILS_URL + `/${UID}/change-email`,
      () => dispatch(userEmailUpdateSuccess()),
      (err: any) => {
        dispatch(userEmailUpdateError(err))
      },
      details,
      METHOD.POST,
      { showToast: showToast }
    )
  }

export const userEmailUpdateSuccess =
  (): ThunkAction<void, Store, unknown, Action<string>> => (dispatch) => {
    dispatch({
      type: UPDATE_USER_EMAIL_DETAILS.UPDATE_USER_EMAIL_DETAILS_SUCCESS,
    })
  }

export const userEmailUpdateError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_USER_EMAIL_DETAILS.UPDATE_USER_EMAIL_DETAILS_ERORR,
      payload: err.message,
    })
  }

// ************** User Email Varify ******************

export const userEmailVarify =
  (
    showToast = true,
    vCode: any,
    UID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(userEmailVarifyInit(showToast, vCode, UID))
  }

export const userEmailVarifyInit =
  (
    showToast: boolean,
    vCode: any,
    UID: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: VERIFY_USER_EMAIL_DETAILS.VERIFY_USER_EMAIL_DETAILS_INITIALIZATION,
    })
    apiCall(
      UPDATE_USER_DETAILS_URL +
        `/${UID}/verify-email?verification_code=${vCode}`,
      () => dispatch(userEmailVarifySuccess()),
      (err: any) => {
        dispatch(userEmailVarifyError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const userEmailVarifySuccess =
  (): ThunkAction<void, Store, unknown, Action<string>> => (dispatch) => {
    dispatch({
      type: VERIFY_USER_EMAIL_DETAILS.VERIFY_USER_EMAIL_DETAILS_SUCCESS,
    })
  }

export const userEmailVarifyError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: VERIFY_USER_EMAIL_DETAILS.VERIFY_USER_EMAIL_DETAILS_ERORR,
      payload: err.message,
    })
  }
// ************** User List Get ******************
export const userListGet =
  (
    showToast = true,
    role?: string | string[],
    institute?: string | number,
    department?: string | number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(userListGetInit(showToast, role, institute, department))
  }

export const userListGetInit =
  (
    showToast: boolean,
    role?: string | string[],
    institute?: string | number,
    department?: string | number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_USERS_LIST.GET_USERS_LIST_INITLIZATION,
    })
    apiCall(
      UPDATE_USER_DETAILS_URL +
        `?role=${Array.isArray(role) ? role?.join(',') : role}` +
        `${institute ? `&institute=${institute}` : ''}` +
        `${department ? `&department=${department}` : ''}`,
      (res: any) => dispatch(userListGetSuccess(res)),
      (err: any) => {
        dispatch(userListGetError(err))
      },
      {},
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const userListGetSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_USERS_LIST.GET_USERS_LIST_SUCCESS,
      payload: res,
    })
  }

export const userListGetError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_USERS_LIST.GET_USERS_LIST_ERORR,
      payload: err.message,
    })
  }

// ************** External candidate registration ******************

export const externalCandidateRegistration =
  (
    showToast = false,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      externalCandidateRegistrationInit(
        showToast,
        payload,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const externalCandidateRegistrationInit =
  (
    showToast,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXTERNAL_CANDIDATE_REGISTRATION.EXTERNAL_CANDIDATE_REGISTRATION_INITIALIZATION,
    })
    apiCall(
      REGISTRATION_URL,
      (res: any) =>
        dispatch(externalCandidateRegistrationSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(externalCandidateRegistrationError(err, _handleFailure))
      },
      payload,
      METHOD.POST,
      { showToast: showToast }
    )
  }

export const externalCandidateRegistrationSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXTERNAL_CANDIDATE_REGISTRATION.EXTERNAL_CANDIDATE_REGISTRATION_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const externalCandidateRegistrationError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  () => {
    let msg = ''
    if (err?.data?.email?.[0]) {
      showErrorToastMessage('You are already registered with us\nPlease login.')
      setTimeout(() => {
        window.location.href = '/auth/login'
      }, 3000)
      return
    }
    if (err?.data?.mobile_number?.[0]) {
      if (msg != '') {
        msg += '\n'
      }
      msg += 'This mobile number already exists.'
    }
    if (err?.data?.not_invited) {
      msg += err?.data?.not_invited
    }
    showErrorToastMessage(msg || err?.message)
  }

// ************** Forgot password ******************

export const forgotPassword =
  (
    values: string,
    handleShow
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD.FORGOT_PASSWORD_INITIALIZATION,
    })
    apiCall(
      FORGOT_PASSWORD_URL,
      () => {
        dispatch({
          type: FORGOT_PASSWORD.FORGOT_PASSWORD_SUCCESS,
        })
        handleShow()
      },
      (err: any) => {
        dispatch({
          type: FORGOT_PASSWORD.FORGOT_PASSWORD_ERORR,
        })
        showErrorToastMessage(
          err?.data?.email?.[0] || err?.message || 'Something went wrong'
        )
      },
      {
        email: values,
      },
      METHOD.POST,
      { showToast: false }
    )
  }

// ************** Reset password ******************

export const resetPassword =
  (values, handleShow): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: RESET_PASSWORD.RESET_PASSWORD_INITIALIZATION,
    })
    apiCall(
      RESET_PASSWORD_URL,
      () => {
        dispatch({
          type: RESET_PASSWORD.RESET_PASSWORD_SUCCESS,
        })
        handleShow()
      },
      (err: any) => {
        dispatch({
          type: RESET_PASSWORD.RESET_PASSWORD_ERORR,
        })
        showErrorToastMessage(
          err?.data?.verification_code?.[0] ||
            err?.data?.password?.[0] ||
            err?.message ||
            'Something went wrong'
        )
      },
      {
        verification_code: values.verificationCode,
        password_1: values.newPassword,
        password_2: values.confirmPassword,
      },
      METHOD.POST,
      { showToast: false }
    )
  }

// ************** Fetch Username & Password ******************

export const fetchRandomUsernamePassword =
  (payload): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(fetchRandomUsernamePasswordInit(payload))
  }

export const fetchRandomUsernamePasswordInit =
  (payload): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: FETCH_RANDOM_USERNAME_PWD.FETCH_RANDOM_USERNAME_PWD_INITIALIZATION,
    })
    apiCall(
      FETCH_RANDOM_USERNAME_PWD_URL,
      (res: any) => dispatch(fetchRandomUsernamePasswordSuccess(res)),
      (err: any) => {
        dispatch(fetchRandomUsernamePasswordError(err))
      },
      payload,
      METHOD.POST,
      { showToast: false }
    )
  }

export const fetchRandomUsernamePasswordSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: FETCH_RANDOM_USERNAME_PWD.FETCH_RANDOM_USERNAME_PWD_SUCCESS,
      payload: res,
    })
  }

export const fetchRandomUsernamePasswordError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: FETCH_RANDOM_USERNAME_PWD.FETCH_RANDOM_USERNAME_PWD_ERROR,
      payload: err?.data?.message || err?.data?.message?.non_field_errors,
    })
  }

/**
 * candidate register
 * @param values
 * @returns
 */
export const registerCandidate =
  (values, modalHandler): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: REGISTER_CANDIDATE_ACTION.REGISTER_CANDIDATE_INITIALIZATION,
    })
    apiCall(
      REGISTRATION_URL,
      () => {
        dispatch({
          type: REGISTER_CANDIDATE_ACTION.REGISTER_CANDIDATE_SUCCESS,
        })
        modalHandler()
      },
      (err: any) => {
        dispatch({
          type: REGISTER_CANDIDATE_ACTION.REGISTER_CANDIDATE_FAILED,
        })
        const field = Object.keys(err?.data)[0]
        const mobileError =
          'mobile_number' === field && 'Mobile is already registered.'
        const emailError = 'email' === field && 'Email is already registered.'
        const emailNotInvited =
          'not_invited' === field && 'This email address is not invited yet.'

        showErrorToastMessage(mobileError || emailError || emailNotInvited)
      },
      {
        ...values,
      },
      METHOD.POST,
      { showToast: false }
    )
  }

export const getQualifications =
  (): ThunkAction<void, Store, unknown, Action<string>> => (dispatch) => {
    dispatch({
      type: GET_QUALIFICATION.GET_QUALIFICATION_INITIALIZATION,
    })
    apiCall(
      GET_QUALIFICATION_URL,
      (res: any) => {
        dispatch({
          type: GET_QUALIFICATION.GET_QUALIFICATION_SUCCESS,
          payload: res,
        })
      },
      () => {
        dispatch({
          type: GET_QUALIFICATION.GET_QUALIFICATION_FAILED,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
